import { BetOutcomeModel } from '@shared/types';

import { BetOutcomeFormValues } from '../../../BetSystemSettingsForms';

export const getBetOutcomeFormValuesFromModel = (betOutcome: BetOutcomeModel): BetOutcomeFormValues => {
  const { id, bettors, resultType, eventId, ...restFields } = betOutcome;

  return restFields;
};
